import { ReactNode } from "react"
import AppLayout from "@/layouts/AppLayout"
import AdminNavigation from "@/components/admin/AdminNavigation"
import DashboardTopbar from "@/components/DashboardTopbar"
import { usePage } from "@inertiajs/react"
import { AdminDashboardProps } from "@/types/types"
import Card from "@/components/Card"
import { BarChart } from "@tremor/react"

export const chartSettings = {
  xAxis: [
    {
      dataKey: "date",
      tickLabelStyle: { display: "none" },
      disableTicks: true,
      disableLine: true,
    },
  ],
  yAxis: [
    {
      tickLabelStyle: { fontSize: 12, fill: "#6b7280" },
      disableLine: true,
      disableTicks: true,
    },
  ],
  grid: {
    horizontal: true,
  },
  margin: { left: 0, right: 0, bottom: 0 },
  hideLegend: true,
}

const AdminDashboardPage = () => {
  const {
    total_games,
    total_users,
    games_last_30_count,
    games_last_30_chart,
    users_last_30_count,
    users_last_30_chart,
  } = usePage<AdminDashboardProps>().props

  return (
    <>
      <DashboardTopbar title="Admin" />
      <AdminNavigation />

      <div className="padding grid w-full max-w-7xl gap-6 py-4 sm:py-6 lg:grid-cols-2 lg:py-8">
        <Card title="Total games" value={total_games} />
        <Card
          title="Total users"
          className="row-start-3 lg:row-start-auto"
          value={total_users}
        />

        <Card title="Games created (Last 30 days)" value={games_last_30_count}>
          <BarChart
            data={games_last_30_chart}
            index="date"
            categories={["New games"]}
            colors={["blue"]}
            startEndOnly
            showLegend={false}
            yAxisWidth={40}
            className="h-full w-full"
          />
        </Card>

        <Card title="Users created (Last 30 days)" value={users_last_30_count}>
          <BarChart
            data={users_last_30_chart}
            index="date"
            categories={["New users"]}
            colors={["blue"]}
            startEndOnly
            showLegend={false}
            yAxisWidth={40}
            className="h-full w-full"
          />
        </Card>
      </div>
    </>
  )
}

export default AdminDashboardPage

AdminDashboardPage.layout = (page: ReactNode) => <AppLayout>{page}</AppLayout>
